import {
  MessageContent,
  ScenarioDataChannelState,
  ScenarioMessage,
} from '@inbox-demo-nx/types';

import { convertScenarioMessageTimestamp } from './convertScenarioMessageTimestamp';

export function convertMessagesToPayloadArray(
  messages: ScenarioDataChannelState['messages'] = []
) {
  return messages
    .flatMap((message) => {
      const singleContentMessages = (
        Array.isArray(message.content)
          ? message.content.map((content) => ({ ...message, content }))
          : [message]
      ) as (Omit<ScenarioMessage, 'content'> & { content: MessageContent })[];
      return singleContentMessages;
    })
    .map(({ createdAt, ...rest }) => ({
      ...rest,
      createdAt: convertScenarioMessageTimestamp(createdAt),
    }))
    .map((item, index, array) => {
      if (array[index - 1]?.createdAt === item.createdAt) {
        // If the consecutive messages have the same timestamp, we need to add a delay to the next message to keep the order.
        const { createdAt, ...rest } = item;
        return { ...rest, createdAt: createdAt + 1 };
      }
      return item;
    });
}
